/**
 * Do not edit directly
 * Generated on Fri, 29 Sep 2023 19:14:15 GMT
 */

export const PharosAssetIconAcademicContent = "assets/icons/academic-content.svg";
export const PharosAssetIconAdd = "assets/icons/add.svg";
export const PharosAssetIconArrowDown = "assets/icons/arrow-down.svg";
export const PharosAssetIconArrowLeft = "assets/icons/arrow-left.svg";
export const PharosAssetIconArrowRight = "assets/icons/arrow-right.svg";
export const PharosAssetIconArrowUp = "assets/icons/arrow-up.svg";
export const PharosAssetIconAttachment = "assets/icons/attachment.svg";
export const PharosAssetIconAudio = "assets/icons/audio.svg";
export const PharosAssetIconBase = "assets/icons/base.svg";
export const PharosAssetIconBook = "assets/icons/book.svg";
export const PharosAssetIconCalendar = "assets/icons/calendar.svg";
export const PharosAssetIconCheckmarkFilledCircle = "assets/icons/checkmark-filled-circle.svg";
export const PharosAssetIconCheckmarkInverse = "assets/icons/checkmark-inverse.svg";
export const PharosAssetIconCheckmarkSmall = "assets/icons/checkmark-small.svg";
export const PharosAssetIconCheckmark = "assets/icons/checkmark.svg";
export const PharosAssetIconChevronDown = "assets/icons/chevron-down.svg";
export const PharosAssetIconChevronLeftLarge = "assets/icons/chevron-left-large.svg";
export const PharosAssetIconChevronLeft = "assets/icons/chevron-left.svg";
export const PharosAssetIconChevronRightLarge = "assets/icons/chevron-right-large.svg";
export const PharosAssetIconChevronRight = "assets/icons/chevron-right.svg";
export const PharosAssetIconChevronUp = "assets/icons/chevron-up.svg";
export const PharosAssetIconCircle = "assets/icons/circle.svg";
export const PharosAssetIconCite = "assets/icons/cite.svg";
export const PharosAssetIconCloseInverse = "assets/icons/close-inverse.svg";
export const PharosAssetIconClose = "assets/icons/close.svg";
export const PharosAssetIconClosedCaptionsOff = "assets/icons/closed-captions-off.svg";
export const PharosAssetIconClosedCaptionsOn = "assets/icons/closed-captions-on.svg";
export const PharosAssetIconCompare = "assets/icons/compare.svg";
export const PharosAssetIconThumbsUp = "assets/icons/thumbs-up.svg";
export const PharosAssetIconThumbsUpFilled = "assets/icons/thumbs-up-filled.svg";
export const PharosAssetIconThumbsDown = "assets/icons/thumbs-down.svg";
export const PharosAssetIconThumbsDownFilled = "assets/icons/thumbs-down-filled.svg";
export const PharosAssetIconCollapse = "assets/icons/shift-right.svg";
export const PharosAssetIconCopy = "assets/icons/copy.svg";
export const PharosAssetIconDashSmall = "assets/icons/dash-small.svg";
export const PharosAssetIconDelete = "assets/icons/delete.svg";
export const PharosAssetIconDownload = "assets/icons/download.svg";
export const PharosAssetIconEdit = "assets/icons/edit.svg";
export const PharosAssetIconEllipsesHorizontal = "assets/icons/ellipses-horizontal.svg";
export const PharosAssetIconEllipsesVertical = "assets/icons/ellipses-vertical.svg";
export const PharosAssetIconEmail = "assets/icons/email.svg";
export const PharosAssetIconExclamationInverse = "assets/icons/exclamation-inverse.svg";
export const PharosAssetIconExclamation = "assets/icons/exclamation.svg";
export const PharosAssetIconExpand = "assets/icons/shift-left.svg";
export const PharosAssetIconFacebook = "assets/icons/facebook.svg";
export const PharosAssetIconFiletypePdf = "assets/icons/filetype-pdf.svg";
export const PharosAssetIconFiletypePpt = "assets/icons/filetype-ppt.svg";
export const PharosAssetIconFiletypeZip = "assets/icons/filetype-zip.svg";
export const PharosAssetIconFitToView = "assets/icons/fit-to-view.svg";
export const PharosAssetIconFitToWidth = "assets/icons/fit-to-width.svg";
export const PharosAssetIconFolderNew = "assets/icons/folder-new.svg";
export const PharosAssetIconFolder = "assets/icons/folder.svg";
export const PharosAssetIconFolderSelected = "assets/icons/folder-selected.svg";
export const PharosAssetIconFullscreenMinimize = "assets/icons/fullscreen-minimize.svg";
export const PharosAssetIconFullscreen = "assets/icons/fullscreen.svg";
export const PharosAssetIconGoogleColor = "assets/icons/google-color.svg";
export const PharosAssetIconGoogle = "assets/icons/google.svg";
export const PharosAssetIconImage = "assets/icons/image.svg";
export const PharosAssetIconInfoInverse = "assets/icons/info-inverse.svg";
export const PharosAssetIconInstagram = "assets/icons/instagram.svg";
export const PharosAssetIconLaptop = "assets/icons/laptop.svg";
export const PharosAssetIconLinkAdd = "assets/icons/link-add.svg";
export const PharosAssetIconLinkExternal = "assets/icons/link-external.svg";
export const PharosAssetIconLink = "assets/icons/link.svg";
export const PharosAssetIconLinkedin = "assets/icons/linkedin.svg";
export const PharosAssetIconMenu = "assets/icons/menu.svg";
export const PharosAssetIconMicrosoftColor = "assets/icons/microsoft-color.svg";
export const PharosAssetIconModePaging = "assets/icons/mode-paging.svg";
export const PharosAssetIconModeScrolling = "assets/icons/mode-scrolling.svg";
export const PharosAssetIconMove = "assets/icons/move.svg";
export const PharosAssetIconNew = "assets/icons/new.svg";
export const PharosAssetIconPartialCircle = "assets/icons/partial-circle.svg";
export const PharosAssetIconPause = "assets/icons/pause.svg";
export const PharosAssetIconPauseLarge = "assets/icons/pause-large.svg";
export const PharosAssetIconPlay = "assets/icons/play.svg";
export const PharosAssetIconPlayLarge = "assets/icons/play-large.svg";
export const PharosAssetIconPrimarySource = "assets/icons/primary-source.svg";
export const PharosAssetIconProfile = "assets/icons/profile.svg";
export const PharosAssetIconQuestionInverse = "assets/icons/question-inverse.svg";
export const PharosAssetIconReorder = "assets/icons/reorder.svg";
export const PharosAssetIconSave = "assets/icons/save.svg";
export const PharosAssetIconSaved = "assets/icons/saved.svg";
export const PharosAssetIconSearch = "assets/icons/search.svg";
export const PharosAssetIconSeekBackward = "assets/icons/seek-backward.svg";
export const PharosAssetIconSeekForward = "assets/icons/seek-forward.svg";
export const PharosAssetIconSend = "assets/icons/send.svg";
export const PharosAssetIconShare = "assets/icons/share.svg";
export const PharosAssetIconSidePanel = "assets/icons/side-panel.svg";
export const PharosAssetIconShiftLeft = "assets/icons/shift-left.svg";
export const PharosAssetIconShiftRight = "assets/icons/shift-right.svg";
export const PharosAssetIconShiftUp = "assets/icons/shift-up.svg";
export const PharosAssetIconShiftDown = "assets/icons/shift-down.svg";
export const PharosAssetIconSoundHigh = "assets/icons/sound-high.svg";
export const PharosAssetIconSoundLow = "assets/icons/sound-low.svg";
export const PharosAssetIconSoundNone = "assets/icons/sound-none.svg";
export const PharosAssetIconTumblr = "assets/icons/tumblr.svg";
export const PharosAssetIconTwitter = "assets/icons/twitter.svg";
export const PharosAssetIconVideo = "assets/icons/video.svg";
export const PharosAssetIconViewGallery = "assets/icons/view-gallery.svg";
export const PharosAssetIconViewGrid = "assets/icons/view-grid.svg";
export const PharosAssetIconViewList = "assets/icons/view-list.svg";
export const PharosAssetIconWorkspace = "assets/icons/workspace.svg";
export const PharosAssetIconWorkspaceSelected = "assets/icons/workspace-selected.svg";
export const PharosAssetIconYoutube = "assets/icons/youtube.svg";
export const PharosAssetIconZoomIn = "assets/icons/zoom-in.svg";
export const PharosAssetIconZoomOut = "assets/icons/zoom-out.svg";
export const PharosBreakpointSmall = "22.5rem"; // 360px
export const PharosBreakpointMedium = "48rem"; // 768px
export const PharosBreakpointLarge = "66rem"; // 1056px
export const PharosBreakpointXlarge = "85rem"; // 1360px
export const PharosBreakpointMax = "99rem"; // 1584px
export const PharosColorJstorRed = "#990000";
export const PharosColorNightBlue15 = "#071d46";
export const PharosColorNightBlue60 = "#8091b3";
export const PharosColorNightBlueBase = "#0d3071";
export const PharosColorGlacierBlue40 = "#0b9ebc";
export const PharosColorGlacierBlue70 = "#79deec";
export const PharosColorGlacierBlue80 = "#b4dee4";
export const PharosColorGlacierBlue90 = "#dcedef";
export const PharosColorGlacierBlueBase = "#27cae1";
export const PharosColorLivingCoral50 = "#c83737";
export const PharosColorLivingCoral53 = "#dd3431";
export const PharosColorLivingCoral80 = "#fc9c9c";
export const PharosColorLivingCoral90 = "#f4d7d7";
export const PharosColorLivingCoralBase = "#fb4848";
export const PharosColorMarbleGray10 = "#1a1a19";
export const PharosColorMarbleGray20 = "#343332";
export const PharosColorMarbleGray30 = "#4d4d4c";
export const PharosColorMarbleGray40 = "#676765";
export const PharosColorMarbleGray50 = "#81807e";
export const PharosColorMarbleGray80 = "#d1cfc7";
export const PharosColorMarbleGray94 = "#f2f1ed";
export const PharosColorMarbleGray97 = "#f9f8f6";
export const PharosColorMarbleGrayBase = "#eae8e1";
export const PharosColorBlack = "#000000";
export const PharosColorWhite = "#ffffff";
export const PharosColorYellow97 = "#fdf9f2";
export const PharosColorYellowBase = "#faa926";
export const PharosColorGreen93 = "#e9f1eb";
export const PharosColorGreenBase = "#268241";
export const PharosColorInteractivePrimary = "#990000";
export const PharosColorInteractiveSecondary = "#000000";
export const PharosColorInteractiveTertiary = "#ffffff";
export const PharosColorUi10 = "#ffffff";
export const PharosColorUi20 = "#f2f1ed";
export const PharosColorUi30 = "#eae8e1";
export const PharosColorUi40 = "#d1cfc7";
export const PharosColorUi50 = "#81807e";
export const PharosColorDisabled = "#eae8e1";
export const PharosColorOverlay = "#000000";
export const PharosColorFeedbackError = "#dd3431";
export const PharosColorFeedbackSuccess = "#268241";
export const PharosColorFeedbackWarning = "#faa926";
export const PharosColorFeedbackInfo = "#0b9ebc";
export const PharosColorText10 = "#1a1a19";
export const PharosColorText20 = "#343332";
export const PharosColorText40 = "#676765";
export const PharosColorText50 = "#81807e";
export const PharosColorTextBase = "#000000";
export const PharosColorTextDisabled = "#676765";
export const PharosColorTextPlaceholder = "#676765";
export const PharosColorTextWhite = "#ffffff";
export const PharosColorFocus = "#0b9ebc";
export const PharosColorHoverPrimary = "#990000";
export const PharosColorHoverSecondary = "#ffffff";
export const PharosColorHoverRow = "#f2f1ed";
export const PharosAlertColorBackgroundBase = "#f2f1ed";
export const PharosAlertColorBackgroundInfo = "#dcedef";
export const PharosAlertColorBackgroundError = "#f4d7d7";
export const PharosAlertColorBackgroundSuccess = "#e9f1eb";
export const PharosAlertColorBackgroundWarning = "#fdf9f2";
export const PharosAlertColorIconBase = "#000000";
export const PharosAlertColorIconInfo = "#0b9ebc";
export const PharosAlertColorIconError = "#dd3431";
export const PharosAlertColorIconSuccess = "#268241";
export const PharosAlertColorIconWarning = "#faa926";
export const PharosAlertColorTextBase = "#000000";
export const PharosAlertColorTextInverse = "#ffffff";
export const PharosAlertColorLinkBase = "#000000";
export const PharosAlertColorLinkInverse = "#ffffff";
export const PharosAlertColorBorderBase = "#f2f1ed";
export const PharosAlertColorBorderInfo = "#0b9ebc";
export const PharosAlertColorBorderError = "#dd3431";
export const PharosAlertColorBorderSuccess = "#268241";
export const PharosAlertColorBorderWarning = "#faa926";
export const PharosButtonPaddingBase = "0.25rem";
export const PharosButtonPaddingCondensed = "0.125rem";
export const PharosButtonPaddingLarge = "0.5rem";
export const PharosButtonColorBasePrimaryBackgroundBase = "#990000";
export const PharosButtonColorBasePrimaryBackgroundHover = "transparent";
export const PharosButtonColorBasePrimaryBackgroundDisabled = "#eae8e1";
export const PharosButtonColorBasePrimaryTextBase = "#ffffff";
export const PharosButtonColorBasePrimaryTextHover = "#990000";
export const PharosButtonColorBasePrimaryTextDisabled = "#676765";
export const PharosButtonColorBasePrimaryBorderBase = "#990000";
export const PharosButtonColorBasePrimaryBorderHover = "#990000";
export const PharosButtonColorBasePrimaryBorderDisabled = "#eae8e1";
export const PharosButtonColorBaseSecondaryBackgroundBase = "transparent";
export const PharosButtonColorBaseSecondaryBackgroundHover = "transparent";
export const PharosButtonColorBaseSecondaryBackgroundDisabled = "#eae8e1";
export const PharosButtonColorBaseSecondaryTextBase = "#000000";
export const PharosButtonColorBaseSecondaryTextHover = "#990000";
export const PharosButtonColorBaseSecondaryTextDisabled = "#676765";
export const PharosButtonColorBaseSecondaryBorderBase = "#d1cfc7";
export const PharosButtonColorBaseSecondaryBorderHover = "#990000";
export const PharosButtonColorBaseSecondaryBorderDisabled = "#eae8e1";
export const PharosButtonColorBaseSubtleBackgroundBase = "transparent";
export const PharosButtonColorBaseSubtleBackgroundHover = "#f2f1ed";
export const PharosButtonColorBaseSubtleBackgroundDisabled = "transparent";
export const PharosButtonColorBaseSubtleTextBase = "#000000";
export const PharosButtonColorBaseSubtleTextHover = "#990000";
export const PharosButtonColorBaseSubtleTextDisabled = "#676765";
export const PharosButtonColorBaseSubtleBorderBase = "transparent";
export const PharosButtonColorBaseSubtleBorderHover = "#f2f1ed";
export const PharosButtonColorBaseSubtleBorderDisabled = "transparent";
export const PharosButtonColorBaseOverlayBackgroundBase = "#1a1a19";
export const PharosButtonColorBaseOverlayBackgroundHover = "#343332";
export const PharosButtonColorBaseOverlayBackgroundDisabled = "#eae8e1";
export const PharosButtonColorBaseOverlayTextBase = "#ffffff";
export const PharosButtonColorBaseOverlayTextHover = "#ffffff";
export const PharosButtonColorBaseOverlayTextDisabled = "#676765";
export const PharosButtonColorBaseOverlayBorderBase = "#1a1a19";
export const PharosButtonColorBaseOverlayBorderHover = "#343332";
export const PharosButtonColorBaseOverlayBorderDisabled = "#eae8e1";
export const PharosButtonColorOnBackgroundPrimaryBackgroundBase = "#990000";
export const PharosButtonColorOnBackgroundPrimaryBackgroundHover = "transparent";
export const PharosButtonColorOnBackgroundPrimaryBackgroundDisabled = "#343332";
export const PharosButtonColorOnBackgroundPrimaryTextBase = "#ffffff";
export const PharosButtonColorOnBackgroundPrimaryTextHover = "#ffffff";
export const PharosButtonColorOnBackgroundPrimaryTextDisabled = "#81807e";
export const PharosButtonColorOnBackgroundPrimaryBorderBase = "#990000";
export const PharosButtonColorOnBackgroundPrimaryBorderHover = "#ffffff";
export const PharosButtonColorOnBackgroundPrimaryBorderDisabled = "#343332";
export const PharosButtonColorOnBackgroundSecondaryBackgroundBase = "transparent";
export const PharosButtonColorOnBackgroundSecondaryBackgroundHover = "transparent";
export const PharosButtonColorOnBackgroundSecondaryBackgroundDisabled = "#343332";
export const PharosButtonColorOnBackgroundSecondaryTextBase = "#ffffff";
export const PharosButtonColorOnBackgroundSecondaryTextHover = "#ffffff";
export const PharosButtonColorOnBackgroundSecondaryTextDisabled = "#81807e";
export const PharosButtonColorOnBackgroundSecondaryBorderBase = "#81807e";
export const PharosButtonColorOnBackgroundSecondaryBorderHover = "#ffffff";
export const PharosButtonColorOnBackgroundSecondaryBorderDisabled = "#343332";
export const PharosButtonColorOnBackgroundSubtleBackgroundBase = "transparent";
export const PharosButtonColorOnBackgroundSubtleBackgroundHover = "#343332";
export const PharosButtonColorOnBackgroundSubtleBackgroundDisabled = "transparent";
export const PharosButtonColorOnBackgroundSubtleTextBase = "#ffffff";
export const PharosButtonColorOnBackgroundSubtleTextHover = "#ffffff";
export const PharosButtonColorOnBackgroundSubtleTextDisabled = "#81807e";
export const PharosButtonColorOnBackgroundSubtleBorderBase = "transparent";
export const PharosButtonColorOnBackgroundSubtleBorderHover = "#343332";
export const PharosButtonColorOnBackgroundSubtleBorderDisabled = "transparent";
export const PharosButtonColorOnBackgroundOverlayBackgroundBase = "#1a1a19";
export const PharosButtonColorOnBackgroundOverlayBackgroundHover = "#343332";
export const PharosButtonColorOnBackgroundOverlayBackgroundDisabled = "#343332";
export const PharosButtonColorOnBackgroundOverlayTextBase = "#ffffff";
export const PharosButtonColorOnBackgroundOverlayTextHover = "#ffffff";
export const PharosButtonColorOnBackgroundOverlayTextDisabled = "#81807e";
export const PharosButtonColorOnBackgroundOverlayBorderBase = "#1a1a19";
export const PharosButtonColorOnBackgroundOverlayBorderHover = "#343332";
export const PharosButtonColorOnBackgroundOverlayBorderDisabled = "#343332";
export const PharosCheckboxGroupSpacingVertical = "0.5rem";
export const PharosCheckboxGroupSpacingHorizontal = "1.5rem";
export const PharosCheckboxColorBackgroundBase = "#ffffff";
export const PharosCoachMarkColorBackgroundDark = "#1a1a19";
export const PharosCoachMarkColorBackgroundLight = "#ffffff";
export const PharosCoachMarkColorBorderDark = "#1a1a19";
export const PharosCoachMarkColorBorderLight = "#eae8e1";
export const PharosCoachMarkColorHeadingDark = "#ffffff";
export const PharosCoachMarkColorHeadingLight = "#343332";
export const PharosCoachMarkColorTextDark = "#d1cfc7";
export const PharosCoachMarkColorTextLight = "#343332";
export const PharosCoachMarkSizeText = "2";
export const PharosCoachMarkSizeBorder = "1px";
export const PharosCoachMarkSizePip = "10px";
export const PharosComboboxColorTextHover = "#990000";
export const PharosComboboxColorTextSelected = "#000000";
export const PharosComboboxColorIconClear = "#81807e";
export const PharosComboboxColorIconDropdown = "#000000";
export const PharosComboboxColorIconCheckmark = "#000000";
export const PharosComboboxColorIconFocus = "#990000";
export const PharosComboboxSizeHeightList = "15rem"; // TODO: Update with core token value
export const PharosComboboxSizeHeightClear = "1.875rem"; // TODO: Update with core token value
export const PharosDropdownMenuItemColorTextBase = "#000000";
export const PharosDropdownMenuItemColorTextHover = "#990000";
export const PharosDropdownMenuItemColorTextDisabled = "#676765";
export const PharosDropdownMenuItemColorTextDescription = "#676765";
export const PharosDropdownMenuItemColorBorderBase = "#d1cfc7";
export const PharosDropdownMenuItemColorBackgroundBase = "#ffffff";
export const PharosDropdownMenuItemColorBackgroundActive = "#eae8e1";
export const PharosDropdownMenuItemColorBackgroundDisabled = "#eae8e1";
export const PharosDropdownMenuItemColorBackgroundHover = "#f2f1ed";
export const PharosDropdownMenuItemColorIconBase = "#000000";
export const PharosDropdownMenuColorBorderBase = "#d1cfc7";
export const PharosDropdownMenuSizeWidthMin = "9rem"; // TODO: Update with core token value
export const PharosDropdownMenuSizeWidthMax = "17rem"; // TODO: Update with core token value
export const PharosFormElementColorTextBase = "#000000";
export const PharosFormElementColorTextRequired = "#dd3431";
export const PharosFormElementColorTextInvalid = "#dd3431";
export const PharosFormElementColorTextDisabled = "#676765";
export const PharosFormElementColorTextPlaceholder = "#676765";
export const PharosFormElementColorBackgroundDisabled = "#eae8e1";
export const PharosFormElementColorBackgroundSelected = "#000000";
export const PharosFormElementColorBorderBase = "#81807e";
export const PharosFormElementColorBorderFocus = "#0b9ebc";
export const PharosFormElementColorBorderInvalid = "#dd3431";
export const PharosFormElementColorBorderDisabled = "#d1cfc7";
export const PharosFormElementSizeTextLabel = "2";
export const PharosFormElementSizeTextInput = "3";
export const PharosLoadingSpinnerColorStrokePrimary = "#990000";
export const PharosLoadingSpinnerColorStrokeSecondary = "#fb4848";
export const PharosModalColorBackgroundContent = "#ffffff";
export const PharosModalColorBorderContent = "#eae8e1";
export const PharosModalColorIconClose = "#81807e";
export const PharosModalColorIconFocus = "#990000";
export const PharosModalSpacingBase = "2rem";
export const PharosModalSizeWidthBase = "40rem"; // TODO: Update with core token value
export const PharosRadioButtonColorBackgroundBase = "#ffffff";
export const PharosRadioGroupSpacingVertical = "0.5rem";
export const PharosRadioGroupSpacingHorizontal = "1.5rem";
export const PharosTextInputColorIconValid = "#268241";
export const PharosTextInputColorIconInvalid = "#dd3431";
export const PharosTextareaSizeHeightBase = "3.5rem"; // TODO: Update with core token value
export const PharosTooltipColorBackgroundBase = "#343332";
export const PharosTooltipColorTextBase = "#ffffff";
export const PharosTooltipSizeTextBase = "2";
export const PharosFontFamilySansSerif = "GT America Standard, Helvetica, Helvetica Neue, Arial, Segoe UI, Roboto, Droid Sans, sans-serif";
export const PharosFontFamilySerif = "Ivar Headline, Times, Georgia, serif";
export const PharosFontFamilyBody = "GT America Standard, Helvetica, Helvetica Neue, Arial, Segoe UI, Roboto, Droid Sans, sans-serif";
export const PharosFontWeightRegular = "400";
export const PharosFontWeightBold = "700";
export const PharosFontSizeMicro = "1";
export const PharosFontSizeSmall = "2";
export const PharosFontSizeBase = "3";
export const PharosFontSizeLarge = "5";
export const PharosFontSizeXlarge = "6";
export const PharosLineHeightXsmall = "1rem"; // 16px
export const PharosLineHeightSmall = "1.25rem"; // 20px
export const PharosLineHeightMedium = "1.5rem"; // 24px
export const PharosLineHeightLarge = "1.75rem"; // 28px
export const PharosLineHeightXlarge = "2.25rem"; // 36px
export const PharosLineHeightHeadingLarge = "1";
export const PharosLineHeightTextBaseCondensed = "1.25rem"; // 20px
export const PharosRadiusBaseStandard = "0.125rem"; // 2px
export const PharosSpacingOneEighthX = "0.125rem"; // 2px
export const PharosSpacingOneQuarterX = "0.25rem"; // 4px
export const PharosSpacingOneHalfX = "0.5rem"; // 8px
export const PharosSpacingThreeQuartersX = "0.75rem"; // 12px
export const PharosSpacing1X = "1rem"; // 16px
export const PharosSpacingOneAndAHalfX = "1.5rem"; // 24px
export const PharosSpacing2X = "2rem"; // 32px
export const PharosSpacing3X = "3rem"; // 48px
export const PharosSpacingThreeAndAHalfX = "3.5rem"; // 56px
export const PharosSpacing5X = "5rem"; // 80px
export const PharosSpacing7X = "7rem"; // 112px
export const PharosSpacing10X = "10rem"; // 160px
export const PharosSpacingGutter = "3rem"; // 48px
export const PharosTransitionBase = "250ms cubic-bezier(0.17, 0.67, 0.83, 0.67)";
export const PharosTransitionDurationShorter = "50ms";
export const PharosTransitionDurationShort = "100ms";
export const PharosTransitionDurationDefault = "250ms";
export const PharosTransitionDurationLong = "500ms";
export const PharosTransitionDurationLonger = "1000ms";
export const PharosTransitionCurveBase = "cubic-bezier(0.17, 0.67, 0.83, 0.67)";
export const PharosTypeScale1 = "1"; // 12px
export const PharosTypeScale2 = "2"; // 14px
export const PharosTypeScale3 = "3"; // 16px
export const PharosTypeScale4 = "4"; // 18px
export const PharosTypeScale5 = "5"; // 20px
export const PharosTypeScale6 = "6"; // 24px
export const PharosTypeScale7 = "7"; // 28px
export const PharosTypeScale8 = "8"; // 32px
export const PharosTypeScale9 = "9"; // 36px
export const PharosTypeScale10 = "10"; // 42px
export const PharosTypeScale11 = "11"; // 48px
export const PharosTypeScale12 = "12"; // 54px
export const PharosTypeScale13 = "13"; // 60px
export const PharosTypeScale14 = "14"; // 68px